
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {DataFeedSubscription} from './DataFeedSubscription';
import {FieldModelDataFeedSubscription} from './DataFeedSubscription';
import {Symbol} from '../core/Symbol';
import {FieldModelSymbol} from '../core/Symbol';

/**
 * DataFeedStartRequest struct
 */
class DataFeedStartRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Map=} subscriptions
   * @param {!Map=} parameters
   * @param {!Array=} allSymbols
   * @constructor
   */
  constructor (parent = new Request(), subscriptions = new Map(), parameters = new Map(), allSymbols = []) {
    super()
    super.copy(parent)
    this.Subscriptions = subscriptions
    this.Parameters = parameters
    this.AllSymbols = allSymbols
  }

  /**
   * Copy struct (shallow copy)
   * @this {!DataFeedStartRequest}
   * @param {!DataFeedStartRequest} other Other struct
   * @returns {!DataFeedStartRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Subscriptions != null) {
      this.Subscriptions = new Map()
      Object.keys(other.Subscriptions).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = new UUID(key)
          if (other.Subscriptions[key] != null) {
            let tempValue
            tempValue = DataFeedSubscription.fromObject(other.Subscriptions[key])
            this.Subscriptions.set(tempKey, tempValue)
          } else {
            this.Subscriptions.set(tempKey, null)
          }
        }
      })
    } else {
      this.Subscriptions = null
    }
    if (other.Parameters != null) {
      this.Parameters = new Map()
      Object.keys(other.Parameters).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = key
          if (other.Parameters[key] != null) {
            let tempValue
            tempValue = other.Parameters[key]
            this.Parameters.set(tempKey, tempValue)
          } else {
            this.Parameters.set(tempKey, null)
          }
        }
      })
    } else {
      this.Parameters = null
    }
    if (other.AllSymbols != null) {
      this.AllSymbols = []
      for (let item of other.AllSymbols) {
        if (item != null) {
          let tempItem
          tempItem = Symbol.fromObject(item)
          this.AllSymbols.push(tempItem)
        } else {
          this.AllSymbols.push(null)
        }
      }
    } else {
      this.AllSymbols = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!DataFeedStartRequest}
   * @returns {!DataFeedStartRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new DataFeedStartRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new DataFeedStartRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!DataFeedStartRequest}
   * @param {!DataFeedStartRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof DataFeedStartRequest)) {
      throw new TypeError('Instance of DataFeedStartRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!DataFeedStartRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Subscriptions: ((this.Subscriptions != null) ? fbe.MapToObject(new Map(Array.from(this.Subscriptions, item => [((item[0] != null) ? item[0].toString() : null), ((item[1] != null) ? item[1] : null)]))) : null),
      Parameters: ((this.Parameters != null) ? fbe.MapToObject(new Map(Array.from(this.Parameters, item => [((item[0] != null) ? item[0] : null), ((item[1] != null) ? item[1] : null)]))) : null),
      AllSymbols: ((this.AllSymbols != null) ? Array.from(this.AllSymbols, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return DataFeedStartRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!DataFeedStartRequest} other Object value
   * @returns {!DataFeedStartRequest} Created struct
   */
  static fromObject (other) {
    return new DataFeedStartRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!DataFeedStartRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return DataFeedStartRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!DataFeedStartRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 2057
  }
}

export { DataFeedStartRequest };

/**
 * Fast Binary Encoding DataFeedStartRequest field model
 */
class FieldModelDataFeedStartRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.Subscriptions = new fbe.FieldModelMap(new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), new FieldModelDataFeedSubscription(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.Parameters = new fbe.FieldModelMap(new fbe.FieldModelString(buffer, this.Subscriptions.fbeOffset + this.Subscriptions.fbeSize), new fbe.FieldModelString(buffer, this.Subscriptions.fbeOffset + this.Subscriptions.fbeSize), buffer, this.Subscriptions.fbeOffset + this.Subscriptions.fbeSize)
    this.AllSymbols = new fbe.FieldModelVector(new FieldModelSymbol(buffer, this.Parameters.fbeOffset + this.Parameters.fbeSize), buffer, this.Parameters.fbeOffset + this.Parameters.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelDataFeedStartRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelDataFeedStartRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelDataFeedStartRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Subscriptions.fbeSize + this.Parameters.fbeSize + this.AllSymbols.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelDataFeedStartRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Subscriptions.fbeExtra + this.Parameters.fbeExtra + this.AllSymbols.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelDataFeedStartRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelDataFeedStartRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelDataFeedStartRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 2057
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelDataFeedStartRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelDataFeedStartRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Subscriptions.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Subscriptions.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Subscriptions.fbeSize

    if ((fbeCurrentSize + this.Parameters.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Parameters.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Parameters.fbeSize

    if ((fbeCurrentSize + this.AllSymbols.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AllSymbols.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllSymbols.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelDataFeedStartRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelDataFeedStartRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelDataFeedStartRequest}
   * @param {!DataFeedStartRequest} fbeValue Default value, defaults is new DataFeedStartRequest()
   * @returns {!DataFeedStartRequest} DataFeedStartRequest value
   */
  get (fbeValue = new DataFeedStartRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelDataFeedStartRequest}
   * @param {!DataFeedStartRequest} fbeValue DataFeedStartRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Subscriptions.fbeSize) <= fbeStructSize) {
      this.Subscriptions.get(fbeValue.Subscriptions)
    } else {
      fbeValue.Subscriptions.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Subscriptions.fbeSize

    if ((fbeCurrentSize + this.Parameters.fbeSize) <= fbeStructSize) {
      this.Parameters.get(fbeValue.Parameters)
    } else {
      fbeValue.Parameters.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Parameters.fbeSize

    if ((fbeCurrentSize + this.AllSymbols.fbeSize) <= fbeStructSize) {
      this.AllSymbols.get(fbeValue.AllSymbols)
    } else {
      fbeValue.AllSymbols.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllSymbols.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelDataFeedStartRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelDataFeedStartRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelDataFeedStartRequest}
   * @param {!DataFeedStartRequest} fbeValue DataFeedStartRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelDataFeedStartRequest}
   * @param {DataFeedStartRequest} fbeValue DataFeedStartRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Subscriptions.set(fbeValue.Subscriptions)
    this.Parameters.set(fbeValue.Parameters)
    this.AllSymbols.set(fbeValue.AllSymbols)
  }
}

export { FieldModelDataFeedStartRequest };

/**
 * Fast Binary Encoding DataFeedStartRequest model
 */
class DataFeedStartRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelDataFeedStartRequest(this.buffer, 4)
  }

  /**
   * Get the DataFeedStartRequest model
   * @this {!DataFeedStartRequestModel}
   * @returns {!FieldModelDataFeedStartRequest} model DataFeedStartRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!DataFeedStartRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!DataFeedStartRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return DataFeedStartRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!DataFeedStartRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelDataFeedStartRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!DataFeedStartRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!DataFeedStartRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!DataFeedStartRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!DataFeedStartRequestModel}
   * @param {!DataFeedStartRequest} value DataFeedStartRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!DataFeedStartRequestModel}
   * @param {!DataFeedStartRequest} value DataFeedStartRequest value, defaults is new DataFeedStartRequest()
   * @return {!object} Deserialized DataFeedStartRequest value and its size
   */
  deserialize (value = new DataFeedStartRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new DataFeedStartRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new DataFeedStartRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!DataFeedStartRequestModel}
   * @param {!number} prev Previous DataFeedStartRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { DataFeedStartRequestModel };
